<template>
  <div
    class="employee-card hover-lift"
    @click="$router.push('/report/' + employee.employee_id)"
  >
    <div class="employee-card-left">
      <div class="employee-card-info">
        <div class="employee-card-name">
          {{ employee.real_name }}
        </div>
        <div class="employee-card-job">
          {{ employee.job_title }}
        </div>
      </div>
    </div>
    <div class="employee-card-right">
      <div class="employee-card-score" :style="{ color: scoreColor }">
        {{ employee.latest_score }}
      </div>
      <div class="employee-card-trend">
        <i v-if="employee.trend === 'up'" class="el-icon-top trend-up"></i>
        <i v-else-if="employee.trend === 'down'" class="el-icon-bottom trend-down"></i>
        <i v-else class="el-icon-minus trend-stable"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmployeeCard',
  props: {
    employee: { type: Object, required: true },
    color: { type: String, default: 'gray' }
  },
  computed: {
    scoreColor() {
      const map = {
        red: 'var(--color-high)',
        orange: 'var(--color-medium)',
        green: 'var(--color-low)',
        gray: 'var(--color-text-muted)'
      }
      return map[this.color] || 'var(--color-text-muted)'
    }
  }
}
</script>

<style scoped>
.employee-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-md);
  margin-bottom: var(--space-sm);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
}

.employee-card-left {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.employee-card-info {
  min-width: 0;
}

.employee-card-name {
  font-weight: 600;
  color: var(--color-text);
  font-size: 14px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.employee-card-job {
  font-size: 12px;
  color: var(--color-text-muted);
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.employee-card-right {
  text-align: right;
}

.employee-card-score {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.employee-card-trend {
  font-size: 12px;
}

.trend-up {
  color: var(--color-high);
}

.trend-down {
  color: var(--color-low);
}

.trend-stable {
  color: var(--color-text-muted);
}
</style>
